import { all, put, select, takeLatest } from 'typed-redux-saga';
import { selectPageModelCategoryId } from 'store/pageModel/selectors';
import { getApiParams } from 'api';
import { instoreServiceActions } from './slice';
import { selectSelectedStoreCode } from '../selectors';
import { InstoreServiceGroup } from './types';
import { fetchServices } from './api';

const { fetchServicesRequest, fetchServicesSuccess, fetchServicesFailed } = instoreServiceActions;

export function* instoreServiceRootSaga() {
	return yield all([takeLatest(fetchServicesRequest.type, () => getServices())]);
}

export function* getServices() {
	try {
		const storeCode = yield select(selectSelectedStoreCode);
		const categoryId = yield select(selectPageModelCategoryId);
		const params = {
			storeCode: String(storeCode),
			categoryId,
		};

		const { url, config } = yield getApiParams(
			'/experience/services-platform/instore-landing/v1/instore-landings/services'
		);
		const services: InstoreServiceGroup[] = yield fetchServices(url, params, config);

		yield put(fetchServicesSuccess({ data: services }));
	} catch (error) {
		yield put(
			fetchServicesFailed({ error: { code: error?.status || 500, message: error.message } })
		);
	}
}
